import { render, staticRenderFns } from "./ResourcesTrackingList.vue?vue&type=template&id=5338612c"
import script from "./ResourcesTrackingList.vue?vue&type=script&lang=js"
export * from "./ResourcesTrackingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports